import { PageHero } from "../components/Sections";
import Seo from "../components/Seo";
import { IMAGES, PAGE_SEO } from "../lib/data";
import ContactForm, { ContactDetails } from "../components/ContactForm";

export default function Contact() {
  return (
    <>
      <Seo {...PAGE_SEO.contact} />
      <PageHero
        crumb="Contact"
        image={IMAGES.contact}
        eyebrow="Contact"
        title="Tell us about your"
        accent="current challenge"
        sub="We respond within one business day. Most discovery calls take 60 minutes and end with a clear set of next steps — whether we work together or not."
      />

      <section id="contact" style={{ background: "var(--off-white)" }}>
        <div className="s-inner">
          <div className="contact-grid">
            <div className="fade-up">
              <span className="s-eye">Get In Touch</span>
              <h2>Let's start a conversation</h2>
              <p style={{ fontSize: "0.93rem", color: "var(--text-muted)", lineHeight: 1.7, marginBottom: 36 }}>Share your biggest supply chain or warehouse challenge and we'll come to the call prepared with relevant questions and ideas.</p>
              <ContactDetails />
            </div>
            <ContactForm withService />
          </div>
        </div>
      </section>
    </>
  );
}
